// Store disabled Quasar CSS style tags
const disabledStyleTags = [];

export function disableQuasarCSS() {
    // Locate all <style> tags in the document
    const styleTags = document.querySelectorAll('style');

    styleTags.forEach((styleTag) => {
        // Check if the style tag contains Quasar-specific styles
        if (styleTag.innerText.includes('.q-unique')) {
            // Mark it with a custom attribute if not already marked
            if (!styleTag.hasAttribute('data-quasar-css')) {
                // Store the style tag in the disabled array
                disabledStyleTags.push(styleTag);
                styleTag.setAttribute('data-quasar-css', 'disabled');

                // Remove the style tag from the DOM
                styleTag.parentNode.removeChild(styleTag);
                console.log('Quasar CSS disabled');
            }
        }
    });
}

export async function enableQuasarCSS() {
    // Check if any Quasar CSS is currently loaded
    const isQuasarCssLoaded = Array.from(document.querySelectorAll('style')).some(styleTag => 
        styleTag.innerText.includes('.q-unique')
    );

    // Load Quasar CSS if it's not already present
    if (!isQuasarCssLoaded) {
        try {
            const quasarCss = await import('@/assets/common/css/quasar.css');
            const styleElement = document.createElement('style');
            styleElement.type = 'text/css';
            styleElement.innerText = quasarCss.default; // Assuming `quasarCss.default` contains the CSS text
            document.head.appendChild(styleElement);
            console.log('Quasar CSS injected');
        } catch (error) {
            console.error('Failed to inject Quasar CSS:', error);
        }
    }

    // Enable any disabled Quasar CSS styles by re-adding them to the DOM
    disabledStyleTags.forEach(styleTag => {
        document.head.appendChild(styleTag); // Re-append the style tag
        styleTag.removeAttribute('data-quasar-css');
    });

    // Clear the array after enabling
    disabledStyleTags.length = 0;

    if (disabledStyleTags.length > 0) {
        console.log('Quasar CSS enabled');
    }
}